import theme from "../../../js/shared/new-theme"

export const defaultStyle = (type, hasError, statusIcon, subtitle) => {
    const palette = theme.palette;
    const isAccordion = type === "accordion";

    return `
	> div {
		background-color: ${palette.common.white};
	}
	header {
		i {
			color: ${palette.green[500].value}
		}
	}
	${statusIcon
            ? `i:first-of-type {
			color: ${hasError ? palette.red[500].value : palette.green[500].value}
		}`
            : ""
        }
	${isAccordion
            ? `
		header { 
			color: ${hasError ? palette.red[500].value : palette.gray[400].value}
		}
	`
            : ""
        } 

	${subtitle
            ? `p:first-of-type {
		color: ${palette.blue[500].value}
		}`
            : ""
        }
`;
};
